import React from "react";
import { GatsbyImage } from "gatsby-plugin-image"
import Markdown from "../utility/markdown";
import getRatio from "../utility/getRatio";
import RichButton from "../utility/rich-button";

const TextImage = ({component}) => {
    const {left, right} = getRatio(component.ratio)
    return (
        <div className="m-auto md:w-11/12 grid grid-cols-1 md:grid-cols-12 md:gap-8 mb-14">
            <div className={`${left} leading-none mb-8 lg:mb-0 text-${component.contentAlignment}`}>
                <Markdown body={component.content.data.content}></Markdown>
                {component.buttons?.map((button)=>(
                    <RichButton key={button.id} button={button} />
                ))}
            </div>
            <div className={`${right} leading-none`}>
            <GatsbyImage imgClassName="rounded-3xl" className="min-w-full w-auto h-auto rounded-3xlmb-14" image={component.image.localFile.childImageSharp.gatsbyImageData} alt={component.image.alternativeText} />
            </div>
        </div>
    )
}

export default TextImage